import fly from "../config/flyio";

export default {
    // 初始化
    getQuoteInitData() {
      return fly.get("/VHISLoveYourSelf/PremiumList");
    },
    submitQuoteData(data){
      return fly.post("/VHISLoveYourSelf/Quote",data);
    },
    submitExistPolicy(data){
      return fly.post("/VHISLoveYourSelf/ValidatePolicyNo",data)
    },
    checkPromoCode(code){
      return fly.get("/VHISLoveYourSelf/CheckPromoCode?PromoCode="+code)
    },
    checkPromoCodeV2(code){
      return fly.get("/VHISLoveYourSelf/CheckPromoCodeV2?PromoCode="+code)
    }
  };